<template>
  <el-dialog
    :title="nodeDialog.type === 'edit' ? '编辑知识点' : '新增知识点'"
    :visible.sync="nodeDialog.visible"
    width="600px"
    @close="nodeDialogClose"
  >
    <el-form :model="nodeDialog.form" label-width="120px" :rules="nodeRules" ref="nodeFormRef">
      <el-form-item label="所属章节" prop="chapterId">
        <el-cascader
          :options="chapterListFiltered"
          :props="cascaderProps"
          v-model="nodeDialog.form.chapterId"
          placeholder="请选择"
          clearable
          :show-all-levels="false"
          style="width: 100%;"
        />
      </el-form-item>
      <el-form-item label="知识点名称" prop="name">
        <el-input v-model="nodeDialog.form.name" />
      </el-form-item>
      <el-form-item label="知识点难易度" prop="difficultyLevel">
        <el-select v-model="nodeDialog.form.difficultyLevel" placeholder="请选择" clearable>
          <el-option
            v-for="(item, index) in difficultyList"
            :key="index"
            :label="item.text"
            :value="index"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="nodeDialogClose">取消</el-button>
      <el-button type="primary" @click="nodeSubmit">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { save } from '@/request/api/knowledge_graph.js'
import { difficultyList } from '../hypergraph'

export default {
  name: 'KgNodeDialog',
  inject: ['nodeDialog', 'chapterListData', 'getknowledgeData', 'courseId'],
  computed: {
    // 只保留两级：章 -> 节，去掉节以下的 children
    chapterListFiltered() {
      if (!this.chapterListData || !this.chapterListData.length) return []
      return this.chapterListData.map(function (chapter) {
        var children = chapter.children || []
        return {
          id: chapter.id,
          name: chapter.name,
          children: children.map(function (section) {
            return {
              id: section.id,
              name: section.name,
              // 不包含 children，阻止继续展开
            }
          }),
        }
      })
    },
  },
  data() {
    return {
      difficultyList,
      cascaderProps: {
        emitPath: false,
        label: 'name',
        value: 'id',
        children: 'children',
      },
      nodeRules: {
        chapterId: [{ required: true, message: '请选择所属章节', trigger: 'change' }],
        name: [{ required: true, message: '请输入知识点名称', trigger: 'blur' }],
        difficultyLevel: [{ required: true, message: '请选择难易度', trigger: 'change' }],
      },
    }
  },
  methods: {
    nodeDialogClose() {
      this.nodeDialog.visible = false
      this.nodeDialog.type = 'add'
      this.nodeDialog.form = { chapterId: '', name: '', difficultyLevel: 0 }
    },
    nodeSubmit() {
      this.$refs.nodeFormRef.validate(valid => {
        if (valid) {
          var form = this.nodeDialog.form
          var params = {
            id: form.id,
            chapterId: form.chapterId,
            name: form.name,
            difficultyLevel: form.difficultyLevel,
            courseId: this.courseId.value,
          }
          save(params).then(res => {
            if (res.code != 0) return this.$message.error(res.msg || '操作失败')
            this.$message.success('操作成功')
            this.nodeDialogClose()
            this.getknowledgeData()
          })
        }
      })
    },
  },
}
</script>
